import {saleScheduledAndHasTickets, shouldShowSaleEndsLabel} from '@wix/wix-events-commons-statics'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Badge} from 'wix-ui-tpa/cssVars'
import s from './custom-dates-label.scss'
import {CustomDatesLabelProps} from './index'

export const CustomDatesLabel = ({ticket}: CustomDatesLabelProps) => {
  const {t} = useTranslation()

  if (!ticket) {
    return null
  }

  if (saleScheduledAndHasTickets(ticket)) {
    return (
      <Badge className={s.label}>
        {t('seatings_custom_dates_goes_on_sale', {date: ticket.salePeriod.formattedSaleStartDate})}
      </Badge>
    )
  }

  if (shouldShowSaleEndsLabel(ticket)) {
    return (
      <Badge className={s.label}>
        {t('seatings_custom_dates_sale_ends', {date: ticket.salePeriod.formattedSaleEndDate})}
      </Badge>
    )
  }

  return null
}
